/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

export enum ReservationStatus {
    All = 'all',
    Creating = 'creating',
    Pending = 'pending',
    Confirmed = 'confirmed',
    Reserved = 'reserved',
    Finished = 'finished',
    Cancelled = 'cancelled',
    Deleted = 'deleted',
    Checked = 'checked',
    NoShow = 'no_show',
    Rebooking = 'rebooking',
    GroupPackage = 'group_package',
}

export enum ReservationVisibilityType {
    All = 'all',
    Valid = 'valid',
    Invalid = 'invalid',
    New = 'new',
}

export const ValidReservationStatuses = [
	ReservationStatus.Confirmed,
	ReservationStatus.Reserved,
	ReservationStatus.Finished,
    ReservationStatus.Checked,
    ReservationStatus.Rebooking,
]
